'use client'

import { LineGlobe } from '@qr-front/icons/line-globe'
import { theme } from '@qr-front/ui'
import { QrScreen, TQrScreenProps } from 'features/generator/QrScreen/QrScreen'
import { useAtomValue } from 'jotai'
import { useTranslations } from 'next-intl'

import { websiteUrlAtom } from '../../contentFormSections/WebsiteUrlForm'
import { UrlScreenBackground } from './urlScreenBackground'

export const URL_DEMO_PRIMARY_COLOR = theme.colors['website-bg']

const Content = () => {
	const t = useTranslations()

	const websiteUrl = useAtomValue(websiteUrlAtom)

	return (
		<div className="relative h-full min-h-[505px] w-full bg-website-bg">
			<UrlScreenBackground />
			<div className="type-body-caption absolute left-[7.7%] top-0 z-[2] flex w-[84.6%] items-center justify-center gap-1.5 rounded-full bg-white/60 p-1.5">
				<LineGlobe className="h-4 min-h-4 w-4 min-w-4" />
				<span className="block overflow-hidden text-ellipsis whitespace-nowrap">
					{websiteUrl?.length
						? websiteUrl
						: t('generator__website_screen__placeholder')}
				</span>
			</div>
		</div>
	)
}

export const WebsiteUrlScreen = (props: TQrScreenProps) => (
	<QrScreen
		{...props}
		primaryColor={URL_DEMO_PRIMARY_COLOR}
		content={<Content />}
	/>
)
